<template>
  <div>
    <el-popover placement="bottom" width="700" trigger="click" popper-class="pd0">
      <el-table :data="selectData" border size="mini" :header-cell-style="tableHeaderColor">
        <el-table-column
            v-if="sortDisabled"
            label="序号"
            type="index"
            align="center"
            width="50">
          </el-table-column>
        <template v-for="(column, index) in columns">
          <el-table-column
            :key="index"
            :prop="column.prop"
            header-align="center"
            align="center"
            min-width="100px"
            :label="column.label"
          ></el-table-column>
        </template>
      </el-table>
      <el-button type="text" slot="reference">{{ name }}</el-button>
    </el-popover>
  </div>
</template>
<script>
export default {
  data () {
    return {
      name: '',
      selectData: []
    }
  },
  props: {
    limit: Number,
    value: {
      type: String,
      default: () => {
        return null
      }
    },
    sortDisabled: {
      type: Boolean,
      default: false
    },
    labelValue: {
      type: String,
      default: () => {
        return 'id'
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    queryEntityUrl: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  components: {},
  watch: {
    value: {
      handler (newVal) {
        this.selectData = []
        if (newVal) {
          newVal.split(',').forEach(value => {
            if (value) {
              this.$http
                .get(`${this.queryEntityUrl}?${this.labelValue}=${value}`)
                .then(({ data }) => {
                  if (data[this.labelValue] !== '') {
                    this.selectData.push(data)
                  }
                })
            }
          })
        }
      },
      immediate: true,
      deep: false
    },
    selectData: {
      handler (newVal) {
        this.name = newVal.map(user => { return user.nameCn }).join(',')
      },
      immediate: false,
      deep: false
    }
  },
  methods: {
    // 设置表头颜色
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      return {background: '#f7f7f7'}
    }
  }
}
</script>
<style lang="scss" scoped>
.pd0{
  padding: 0 !important;
}
</style>
    
    
    